/* *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Copyright 2023 - Koninklijk Nederlands Meteorologisch Instituut (KNMI)
 * Copyright 2023 - Finnish Meteorological Institute (FMI)
 * Copyright 2024 - The Norwegian Meteorological Institute (MET Norway)
 * */

import type { GeowebColorPalette } from '../../types';

export const cancelledWarningTimeline: GeowebColorPalette['cancelledWarningTimeline'] =
  {
    published: {
      backgroundColor: '#626262',
      borderColor: '#9A9A9A',
      color: '#FFFFFF',
    },
    publishedHover: {
      backgroundColor: '#3C3C3C',
      borderColor: '#9A9A9A',
      color: '#FFFFFF',
    },
    expired: {
      backgroundColor: '#EFEFEF',
      borderColor: '#626262',
      color: '#626262',
    },
    expiredHover: {
      backgroundColor: '#E2E1E1',
      borderColor: '#626262',
      color: '#3C3C3C',
    },
  };
